import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import {
  ReviewSurveyReport,
  ReviewSurveyReportResponse,
} from 'ha/services/apiV2/types/ReviewSurveyReport';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) =>
  ({ surveyUUID, payload }: ReviewSurveyReport) =>
    makeCall<ReviewSurveyReportResponse>(
      'POST',
      `${APIV2_URL}/review/survey/${surveyUUID}/report`,
      {
        data: { payload },
      },
    );
